import React, { createContext, useContext, useEffect, useState } from 'react';

export enum AppThemeEnum {
  light = 'light',
  dark = 'dark',
}

export enum BrandKit {
  ALX = 'ALX',
  FIT = 'FIT',
}

const ThemeContext = createContext({
  theme: AppThemeEnum.light as string,
  brandKit: BrandKit.ALX as string,
  toggleTheme: () => {},
});

export const ThemeProvider = ({
  children,
  // White-labeling the UI kit. Apps that only ever run as one brand (set-edu
  // is FIT-only and is not deployed with NX_BRANDING_KIT) pass it explicitly.
  brandKit = process.env['NX_BRANDING_KIT'] || BrandKit.ALX,
}: {
  children: React.ReactNode;
  brandKit?: string;
}) => {
  const [theme, setTheme] = useState(
    localStorage.getItem('theme') || AppThemeEnum.light
  );

  const toggleTheme = () => {
    const newTheme =
      theme === AppThemeEnum.light ? AppThemeEnum.dark : AppThemeEnum.light;
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  useEffect(() => {
    if (theme === AppThemeEnum.dark) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [theme]);

  useEffect(() => {
    if (brandKit === BrandKit.FIT) {
      document.body.classList.add('fit');
    }
  }, [brandKit]);

  return (
    <ThemeContext.Provider value={{ theme, brandKit, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

/**
 * date-fns format for showing a calendar date on this brand: FIT's learners are
 * American, so month-first numeric (PEDS-17309).
 */
export const useDateFormat = () =>
  useTheme().brandKit === BrandKit.FIT ? 'MM/dd/yyyy' : 'MMM dd yyyy';
